// extracted by mini-css-extract-plugin
export default {"root":"PageItemBullets_root__79feh","bullet":"PageItemBullets_bullet__v49LV"};